"use strict";
/**
 * To update enum/file run next SQL command in data-drip

 select CONCAT('export enum WbfOrganizations {',actor_list,'}') as copy_me
 from (SELECT 1, string_agg(CONCAT('"', name, '"', ' = ', '"', id, '"'), ', ') AS actor_list
 FROM organization
 GROUP BY 1) as list;

 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WbfOrganizations = void 0;
// <GENERATED
var WbfOrganizations;
(function (WbfOrganizations) {
    WbfOrganizations["CirrusMd"] = "86fedb98-5f4c-4f24-ad8b-5561eecf06e6";
    WbfOrganizations["IDG FLORIDA"] = "5ca98161-e445-4d93-ab07-b60ef2e654d8";
    WbfOrganizations["Capital Rx Advantage"] = "6f9576a3-df4b-4e9f-a331-3b06857fab9b";
    WbfOrganizations["UNION360"] = "6b007544-3832-4a1f-a47a-e07535e3b2ec";
    WbfOrganizations["IDG Connecticut"] = "f83b85f5-174f-4078-985c-2dd4ed2ae242";
    WbfOrganizations["IDG Illinois"] = "0edf9079-0e0e-4e32-ba8c-1e27e75c3680";
    WbfOrganizations["IDG STATE IS NOT LISTED"] = "610e6357-9d64-43bd-8323-b7fa0f316912";
    WbfOrganizations["Demonstration Org"] = "c253cf67-13fa-4d45-a7c2-7a79951551b3";
    WbfOrganizations["Drivers Demand Justice"] = "bdbed64f-66e3-438f-881c-0b8b45b33b70";
    WbfOrganizations["IDG Machinists Union"] = "dabbb0c3-16db-44d5-b9c8-6b553377faba";
    WbfOrganizations["BCF New York"] = "6966036a-12d4-4a57-a2ad-c119d797edd1";
    WbfOrganizations["IDG New Jersey"] = "bbfc7ad4-ba66-4d01-a3a5-a02d01e50458";
    WbfOrganizations["BeneStream"] = "85b6f94e-4bb2-47fb-b0e2-dbbb823a59f4";
    WbfOrganizations["Modern MD"] = "b9cb7098-8fe5-4cad-9fd7-21cc10f4ffb7";
    WbfOrganizations["Walgreens"] = "252fa029-6955-4d1d-8d08-ef96494d54c6";
    WbfOrganizations["TrustPlus"] = "6c56dd3f-b199-4dae-a2fb-2c83fbb896e8";
    WbfOrganizations["MetroDent"] = "de8afd6b-c15b-4e8e-9347-6b67d06a7d97";
    WbfOrganizations["Discount Drug Network- AllyHealth"] = "6f8a3b92-2c22-446a-b4dd-6beda77a57f1";
    WbfOrganizations["Galaxy Health Network"] = "34e471ee-8b39-41b4-93e4-e9bf87e55f51";
    WbfOrganizations["WBF"] = "02b7931c-a636-4cb6-aeed-96e6a4726cc0";
    WbfOrganizations["IDG New York"] = "55d2b310-53d0-4d73-ac98-614753e9ef40";
    WbfOrganizations["AllyHealth"] = "455ac637-0672-4225-bd17-49d424da7019";
    WbfOrganizations["Medicaid"] = "13cbe11c-e188-4d0a-8eba-f61cf1ecf6e5";
    WbfOrganizations["Member Resources- IDG Legal"] = "f1971d8c-845c-4a3b-a372-340a52f3673b";
    WbfOrganizations["Obran"] = "9487fc5d-2f75-4519-aa89-bfe9c22a70c1";
    WbfOrganizations["MetLife"] = "9f1e8d10-6f8f-46e6-86fe-45fc543fcdef";
    WbfOrganizations["MeMD"] = "f35fd4bc-692f-40a7-8734-e7fa96e6bf7a";
    WbfOrganizations["GVS"] = "bbdc02ae-c74c-4abf-abf9-a1abc5a71a9b";
    WbfOrganizations["The Hartford Financial Services Group, Inc."] = "5ea83284-559e-4ada-b521-6b8cf4f94dc6";
    WbfOrganizations["Washington state - Employment Security Department"] = "76f6c1c6-fa98-46e3-9ab3-da083c4654fa";
    WbfOrganizations["Drivers Union"] = "1f0636ef-588f-4dbd-ab55-114750af7dc2";
})(WbfOrganizations || (exports.WbfOrganizations = WbfOrganizations = {}));
// >
//# sourceMappingURL=wbf-organizations.js.map